/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClickerSessionStatsDto } from '../../models/clicker-session-stats-dto';

export interface ClickerSessionsControllerGetStats$Params {
  id: string;
}

export function clickerSessionsControllerGetStats(http: HttpClient, rootUrl: string, params: ClickerSessionsControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ClickerSessionStatsDto>> {
  const rb = new RequestBuilder(rootUrl, clickerSessionsControllerGetStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClickerSessionStatsDto>;
    })
  );
}

clickerSessionsControllerGetStats.PATH = '/clicker/sessions/{id}/stats';
